module.exports = __webpack_public_path__ + "img/rfid发卡器.b4e6da6e.jpg";